import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

interface SEOProps {
  description?: string;
  name?: string;
}

const SEO: React.FC<SEOProps> = ({
  description = "Your Personal and Product Studio – Reinvented with AI",
  name = "Showcasaai",
}) => {
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean);
  let title = "Showcasaai";
  if (pathParts.length === 0) {
    title += " / Home";
  } else if (pathParts[0]?.toLowerCase() === 'studio' && pathParts[1]?.toLowerCase() === 'cinemotion') {
    title += " / Cinemotion";
  } else if (pathParts[0]?.toLowerCase() === 'studio' && pathParts[1]?.toLowerCase() === 'podcast') {
    title += " / Podcast";
  } else if (pathParts[0]?.toLowerCase() === 'showcase' && pathParts[1]?.toLowerCase() === 'model' && pathParts[2]) {
    title += " / Showcase";
  } else if (pathParts[0]?.toLowerCase() === 'idea-board' && pathParts[1]?.toLowerCase() === 'cartoon') {
    title += " / Cartoon";
  } else if (pathParts[0]?.toLowerCase() === 'studio' && pathParts[1]?.toLowerCase() === 'comingsoon') {
    title += " / Comingsoon";
  }  else if (pathParts[0]?.toLowerCase() === 'studio' && pathParts[1]?.toLowerCase() === 'photo-talks') {
    title += " / Photo Talks";
  }else {
    let section = pathParts
      .map(seg => seg.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '))
      .join(' / ');
    title += ` / ${section}`;
  }

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="name" content={name} />
    </Helmet>
  );
};

export default SEO;
